import React, { useState } from 'react';
import './navbar.css';
import logo from '../../assets/logo.png';
import { Link } from 'react-scroll';
import menu from '../../assets/menu.png';
import x from '../../assets/x.png';

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <div>
      <nav className="navbar">
          <img src={logo} alt="logo" className="logo" />
          <div className="desktopMenu">
              <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuItem">Home</Link>
              <Link activeClass='active' to='about' spy={true} smooth={true} offset={0} duration={500} className="desktopMenuItem">About</Link>
              <Link activeClass='active' to='portfolio' spy={true} smooth={true} offset={0} duration={500} className="desktopMenuItem">Portfolio</Link>
              <Link activeClass='active' to='clients' spy={true} smooth={true} offset={43} duration={1000} className="desktopMenuItem">Clients</Link>
          </div>

          <img src={showMenu? x : menu} alt="Menu" className="mobMenu" onClick={()=>setShowMenu(!showMenu)}/>
          <div className="navMenu" style={{display: showMenu? 'flex':'none'}}>
              <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>Home</Link>
              <Link activeClass='active' to='about' spy={true} smooth={true} offset={0} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>About</Link>
              <Link activeClass='active' to='portfolio' spy={true} smooth={true} offset={0} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>Portfolio</Link>
              <Link activeClass='active' to='clients' spy={true} smooth={true} offset={43} duration={1000} className="listItem" onClick={()=>setShowMenu(false)}>Clients</Link>
          </div>
      </nav>
      <div className="overlay" style={{display: showMenu? 'flex':'none'}} onClick={()=>setShowMenu(false)}></div>
    </div>
  )
}

export default Navbar
